// is variable defined?
function isDefined(prom) {
    return ((prom !== undefined) && (typeof prom !== typeof undefined));
}

// Cover overlay
function showCoverLayer() {
    $("#cover-layer").height(getDocHeight()).addClass("visible");
}

function hideCoverLayer() {
    $("#cover-layer").height(0).removeClass("visible");
}

// is variable object?
function isObject(prom)
{
    if(isDefined(prom)) {if (typeof prom === 'object') {return true;}}
    return false;
}

// is variable bool?
function isBoolean(prom)
{
    if(isDefined(prom)) {if (typeof prom === "boolean") {return true;}}
    return false;
}

// is variable function?
function isFunction(prom){
    if(isDefined(prom)) {if (typeof prom === 'function') {return true;}}
    return false;
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

// generate uniq id
function uniqid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

// Strings operations
function str_replace(string, pattern, replace, position) {
    if(!isDefined(string) || !isDefined(pattern) || !isDefined(replace)){
        console.log("Insufficient number od parameters in function str_replace");
        return;
    }
    if(!isDefined(position)){
        string = string.replace(new RegExp(pattern, 'g'), replace);
    } else {
        let nth = 0;
        let reg = new RegExp(pattern, "g");
        string = string.replace(reg, function (match, i, original) {
            nth++;
            return (nth === position) ? replace : match;
        });
    }
    return string;
}

String.prototype.toDate = function(format)
{
    let normalized      = this.replace(/[^a-zA-Z0-9]/g, '-');
    let normalizedFormat= format.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
    let formatItems     = normalizedFormat.split('-');
    let dateItems       = normalized.split('-');

    let monthIndex  = formatItems.indexOf("mm");
    let dayIndex    = formatItems.indexOf("dd");
    let yearIndex   = formatItems.indexOf("yyyy");
    let hourIndex     = formatItems.indexOf("hh");
    let minutesIndex  = formatItems.indexOf("ii");
    let secondsIndex  = formatItems.indexOf("ss");

    let today = new Date();

    let year  = yearIndex>-1  ? dateItems[yearIndex]    : today.getFullYear();
    let month = monthIndex>-1 ? dateItems[monthIndex]-1 : today.getMonth()-1;
    let day   = dayIndex>-1   ? dateItems[dayIndex]     : today.getDate();

    let hour    = hourIndex>-1      ? dateItems[hourIndex]    : today.getHours();
    let minute  = minutesIndex>-1   ? dateItems[minutesIndex] : today.getMinutes();
    let second  = secondsIndex>-1   ? dateItems[secondsIndex] : today.getSeconds();

    return new Date(year,month,day,hour,minute,second);
};

// Get document real height
function getDocHeight() {
    let D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}

// Get real container height
function getContainerHeight(element, byElementsInside) {
    if (!isDefined(byElementsInside)) {
        byElementsInside = false;
    }
    if (byElementsInside) {
        let total = 0;
        element.children().each(function() {
            if($(this).is(":visible")) {
                total += $(this).outerHeight();
            }
        });
        return total;
    } else {
        return element.outerHeight(true);
    }
}

// files operations
function loadImageFromFile(file, callback) {
    let reader = new FileReader(file);
    reader.readAsDataURL(file);
    reader.onload = function (e) {
        let img = new Image();
        let origH;
        let origW;
        img.src = e.target.result;
        img.onload = function () {
            origH = this.height;
            origW = this.width;
            if (origH > origW) {
                img.height = 150;
            }
            callback(img);
        };
    };
}

function getFileInfo(file) {
    return {
        basename: file.name.replace(/\\/g, '/').replace(/.*\//, ''),
        extension: file.name.split('.').pop().toLowerCase(),
        size: (file.size / 1024) / 1024
    };
}

function textAreaAdjust(o) {
    o.style.height = "1px";
    o.style.height = (25+o.scrollHeight)+"px";
}

/* Change default options to defined options */

function parseOptions(options_def, options_new) {

    $.each(options_new, function (property, value) {
        $.each(options_def, function (prop, val) {
            if (prop === property) {
                if((!isDefined(val) || val == null) && isDefined(value)){
                    options_def[prop] = value;
                } else {
                    if (isObject(val) && isObject(value)) {
                        parseOptions(val, value);
                    } else {
                        if (isObject(val) && !isObject(value)) {
                            console.log("Wrong option value, it must be object: " + prop + "");
                        } else {
                            if(isDefined(value)) {
                                if (value === "true" || value === "false") {
                                    options_def[prop] = (value === 'true');
                                } else {
                                    if (value !== "") {
                                        options_def[prop] = value;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    });
}

var CustomURL = function(url){

    url = ((isDefined(url)) ? url : window.location.href);

    var BaseUrl;
    var UrlGetParams = {};

    var self = this;

    function getParams(){
        var split = url.split("?");
        BaseUrl = split[0];
        if(isDefined(split[1])){
            var getParams = split[1].split('&');
            for (var i = 0; i < getParams.length; i++) {
                var getParam = getParams[i].split('=');
                UrlGetParams[getParam[0]] = getParam[1];
            }
        }
    }

    function constructGetPart() {
        var getPart = "";

        if(Object.keys(UrlGetParams).length > 0){
            getPart += "?";
        }

        var i = 0;
        $.each(UrlGetParams, function (key,val) {
            getPart += ((i > 0) ? "&" : "")+key+"="+val;
            i++;
        });

        return getPart;
    }

    function constructUrl() {
        return BaseUrl + constructGetPart();
    }

    this.changeUrl = function(url){
        if(isDefined(url)){
            self.url = url;
            clear();
            getParams();
        }
    };

    var clear = function(){
        UrlGetParams = {};
    };

    this.getParameters = function(){
        return UrlGetParams;
    };

    this.getBaseUrl = function(){
        return BaseUrl;
    };

    this.getFullUrl = function () {
        return constructUrl();
    };

    this.useThisUrl = function(title,noreload){

        if(!isBoolean(noreload)){
            noreload = false;
        }

        var UrlConstruct = constructUrl();

        if (noreload) {
            if (typeof (history.pushState) !== "undefined") {
                var obj = {Title: title, Url: UrlConstruct};
                history.pushState(obj, obj.Title, UrlConstruct);
            } else {
                location.replace(UrlConstruct);
            }
        } else {
            location.replace(UrlConstruct);
        }
    };

    this.parameterExists = function(name) {
        return isDefined(UrlGetParams[name]);
    };

    this.addParameter = function(name, value){
        if(!self.parameterExists(name)){
            UrlGetParams[name] = value;
        } else {
            self.changeParameter(name, value);
        }
    };

    this.changeParameter = function(name, value){
        if(self.parameterExists(name)){
            UrlGetParams[name] = value;
        }
    };

    this.getUrlParameter = function(name) {
        if(self.parameterExists(name)) {
            return UrlGetParams[name];
        } else {
            return false;
        }
    };

    getParams();
};

(function( $ ) {

    $.fn.batchImageLoad = function (options) {
        var images = $(this);
        var originalTotalImagesCount = images.length;
        var totalImagesCount = originalTotalImagesCount;
        var elementsLoaded = 0;

        // Init
        $.fn.batchImageLoad.defaults = {
            loadingCompleteCallback: null,
            imageLoadedCallback: null
        };

        var opts = $.extend({}, $.fn.batchImageLoad.defaults, options);

        // Start
        images.each(function () {
            if ($(this)[0].complete) {
                totalImagesCount--;
                if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                // The image is loading, so attach the listener
            } else {
                $(this).on('load', function () {
                    elementsLoaded++;
                    if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                    // An image has been loaded
                    if (elementsLoaded >= totalImagesCount)
                        if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
                });
                $(this).on('error', function () {
                    elementsLoaded++;
                    if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                    // The image has errored
                    if (elementsLoaded >= totalImagesCount)
                        if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
                });
            }
        });
        // There are no unloaded images
        if (totalImagesCount <= 0)
            if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
    };

    $.fn.centerIntoParent = function (parent) {

        let elem = $(this);

        if (!isDefined(parent.css("position"))) {
            parent.css({"position": "relative"});
        }

        function reposition() {
            let parenTop = parent.offset().top;
            let parentHeight = getContainerHeight(parent);
            let parentWidth = parent.outerWidth(true);
            let winTop = $(window).scrollTop();
            let winHeight = $(window).height();
            let elemHeight = getContainerHeight(elem);
            let elemWidth = elem.outerWidth(true);
            let visible;
            let cut;
            let top = 0;

            if (winTop < parenTop) {
                cut = 0;
                if ((winTop + winHeight) >= parenTop) {
                    if ((winTop + winHeight) > (parenTop + parentHeight)) {
                        visible = winHeight - (parenTop - winTop) - ((winTop + winHeight) - (parenTop + parentHeight));
                    } else {
                        visible = winHeight - (parenTop - winTop);
                    }
                } else {
                    visible = 0;
                }
                if (visible > 0) {
                    if (visible > elemHeight) {
                        top = cut + (visible / 2) - elemHeight / 2;
                    }
                }
            } else {
                top = parentHeight - elemHeight;
                if (winTop <= parenTop + parentHeight) {
                    cut = winTop - parenTop;
                    if ((winTop + winHeight) > (parenTop + parentHeight)) {
                        visible = winHeight - ((winTop + winHeight) - (parenTop + parentHeight));
                    } else {
                        visible = winHeight;
                    }
                } else {
                    visible = 0;
                }
                if (visible > 0) {
                    if (visible > elemHeight) {
                        top = cut + (visible / 2) - elemHeight / 2;
                    }
                }
            }

            let left = (parentWidth / 2) - (elemWidth / 2);

            elem.css({
                "position": "absolute",
                "top": top,
                "left": left
            });
        }

        $(window).scroll(function () {
            reposition();
        });

        reposition();
    };

    $.fn.centerToScreen = function () {
        let elem = $(this);
        elem.css({
            "position": "fixed",
            "top": ($(window).height() / 2 - getContainerHeight($(this)) / 2),
            "left": ($(window).width() / 2 - $(this).outerWidth(true) / 2)
        });
    };

    $.fn.isVisible = function () {
        let elem = $(this);

        if(elem.is('body')){
            return true;
        }
        if(!elem.is(':visible')){
            return false;
        }
        if(elem.css('visibility') === "hidden"){
            return false;
        }
        if(parseInt(elem.css('opacity')) === 0){
            return false;
        }
        if(elem.width() === 0 || elem.height === 0){
            return false;
        }
        if(!elem.parent().isVisible()){
            return false;
        }
        return true;
    };

})( jQuery );

(function (window, $, undefined) {

    if (typeof $ !== 'function') {
        return console.error('jQuery is missing, load it please');
    }

    $.progress = {

        insert: function (target) {

            let $progress;

            if(!isDefined(target)){
                target = $("body");
            }

            if ((target).is($("body"))) {
                showCoverLayer();
                $progress = $('<div class="progress-dialog visible"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div>');
                $("body").append($progress);
            } else {

                $progress = $('' +
                    '<div class="progress"> ' +
                    '<div class="progress-body filled"> ' +
                    '<div class="icon">' +
                    '<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> ' +
                    '</div>' +
                    '</div> ' +
                    '</div>' +
                    '');

                if (target.css("position").toString() === "static") {
                    target.css({"position": "relative"});
                }
                target.append($progress);
                $progress.css({"position": "absolute", "top": 0, "left": 0});
                $progress.find(".icon").centerIntoParent($progress.find(".progress-body"));
            }
            return $progress;
        },

        remove: function (progress) {
            if (isObject(progress)) {
                progress.remove();
                hideCoverLayer();
            }
        }

    };

    $.progressBar = {

        insert: function (target) {

            if (isObject(target)) {

                $progress = $('' +
                    '<div class="progress-bar">' +
                    '<div class="progress-body">' +
                    '<div class="percentage">0&nbsp;%</div>' +
                    '<div class="progress-completed"></div>' +
                    '</div>' +
                    '</div>');

                target.append($progress);
                return $progress;
            }
        },

        update: function (progress, percent) {
            if (isObject(progress)) {
                progress.find(".percentage").html(percent + "&nbsp;%");
                let body = progress.find(".progress-body");
                let size = (body.outerWidth(true) * percent) / 100;
                progress.find(".progress-completed").width(size);
            }
        },

        remove: function (progress) {
            if (isObject(progress)) {
                progress.remove();
            }
        },

        removeInto: function (target) {
            if (isObject(target)) {
                target.find(".progress-bar").remove();
            }
        }

    };

    $.inlineMessages = {
        createGroup: function (target) {
            let group = $('<div class="messages"></div>');
            target.append(group);
            return group;
        },
        insertMessage: function(group, msg, type, duration){

            let icon = null;

            switch (type) {
                case 'error':
                    icon = '<i class="iz iz-red-cross"></i>';
                    break;
                case 'warning':
                    icon = '<i class="iz iz-warning-yellow"></i>';
                    break;
                case 'success':
                default:
                    icon = '<i class="iz iz-check-ok></i>';
                    break;
            }

            let message = $('<div class="message '+type+'"><div class="content-wrap">'+icon+msg+'</div>');
            group.append(message);

            if(isDefined(duration)){
                setTimeout(function () {
                    message.fadeOut(300, function () {
                        message.remove();
                    });
                },duration);
            }
        },
        removeGroup: function (group) {
            group.remove();
        }
    };

})(window, window.jQuery);

function fixScannerInput(text) {
    const replaceArray = {
        "\\+": "1",
        "ě": "2",
        "Ě": "2",
        "š": "3",
        "Š": "3",
        "č": "4",
        "Č": "4",
        "ř": "5",
        "Ř": "5",
        "ž": "6",
        "Ž": "6",
        "ý": "7",
        "Ý": "7",
        "á": "8",
        "Á": "8",
        "í": "9",
        "Í": "9",
        "é": "0",
        "É": "0"
    };
    for (let char in replaceArray) {
        let re = new RegExp(char, 'g');
        text = text.replace(re, replaceArray[char]);
    }

    return text;
}

function initPreparationTabUi(saveLink) {
    let columnCount = 0;

    // Initial setup for existing items
    initializeDraggable();

    $('.export-column').each(function() {
        makeColumnDroppable($(this));
    });

    // Add column button handler
    $('#addColumn').click(function() {
        const column = $('<div>').addClass('export-column').attr('data-column', columnCount);
        column.append($('<h5 class="fas">')
            .text('Zadejte jméno')
            .attr('contenteditable', 'true')
            .on('focus', function() {
                const range = document.createRange();
                const sel = window.getSelection();
                range.selectNodeContents(this);
                range.collapse(false);
                sel.removeAllRanges();
                sel.addRange(range);
            })
            .on('keydown', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    $(this).blur();
                }
            })
        );
        column.append($('<span>').addClass('remove-column').html('&times;'));

        makeColumnDroppable(column);
        $('#exportColumns').append(column);
        columnCount++;
    });

    // Remove column handler
    $(document).on('click', '.remove-column', function() {
        const column = $(this).closest('.export-column');
        column.find('.firm-item').each(function() {
            const firmId = $(this).data('firm-id');
            $(`#unassignedFirms [data-firm-id="${ firmId}"]`).show();
        });
        column.remove();
        columnCount--;
    });

    // Save configuration handler
    $('#saveConfig').click(function() {
        const config = [];
        $('.export-column').each(function() {
            const columnId = $(this).data('column-id') || null;
            const columnName = $(this).find('h5').text().trim();
            const firms = [];
            $(this).find('.firm-item').each(function() {
                firms.push($(this).data('firm-id'));
            });

            config.push({
                id: columnId,
                name: columnName,
                adminFirmIds: firms
            });
        });

        $.nette.ajax({
            url: saveLink,
            method: 'POST',
            data: { config: JSON.stringify(config)}
        });
    });

    function initializeDraggable(element = '.firm-item') {
        $(element).draggable({
            connectToSortable: '.export-column',
            revert: function(valid) {
                if (!valid) {
                    const $item = $(this);
                    const $column = $item.closest('.export-column');

                    if ($column.length) {
                        const firmId = $item.data('firm-id');
                        $(`#unassignedFirms [data-firm-id="${ firmId}"]`).show();
                        $item.remove();
                        return false;
                    }
                }
                return !valid;
            }
        });
    }

    function makeColumnDroppable(column) {
        column.sortable({
            items: '.firm-item',
            placeholder: 'firm-item-placeholder',
            connectWith: '.export-column',
            stop: function(event, ui) {
                const firmId = ui.item.data('firm-id');
                const sourceColumn = ui.item.closest('.export-column');

                // Hide in unassigned list
                $(`#unassignedFirms [data-firm-id="${ firmId}"]`).hide();

                // If it's not in any column (dragged to empty space)
                if (!sourceColumn.length) {
                    $(`#unassignedFirms [data-firm-id="${ firmId}"]`).show();
                    ui.item.remove();
                }
            }
        }).droppable({
            accept: '.firm-item',
            tolerance: 'pointer',
            drop: function(event, ui) {
                const draggedItem = ui.draggable;
                const firmId = draggedItem.data('firm-id');
                const sourceIsUnassigned = draggedItem.closest('#unassignedFirms').length > 0;

                if (sourceIsUnassigned) {
                    const newItem = $('<div>')
                        .addClass('firm-item')
                        .attr('data-firm-id', firmId)
                        .text(draggedItem.text());

                    $(this).append(newItem);
                    draggedItem.hide();
                    initializeDraggable(newItem);
                }
            }
        });
    }

    // Make unassigned area droppable
    $('#unassignedFirms').droppable({
        accept: '.firm-item',
        tolerance: 'pointer',
        drop: function(event, ui) {
            const draggedItem = ui.draggable;
            const firmId = draggedItem.data('firm-id');
            const sourceIsUnassigned = draggedItem.closest('#unassignedFirms').length > 0;

            if (!sourceIsUnassigned) {
                // Show item in unassigned list
                $(`#unassignedFirms [data-firm-id="${ firmId}"]`).show();
                // Remove from column
                draggedItem.remove();
            }
        }
    });
}

function initFoodCodeColorPicker(initialData) {
    if (typeof initialData === 'string' && initialData.length > 0) {
        try {
            initialData = JSON.parse(initialData);
        } catch (e) {
            console.error('Error parsing initialData:', e);
            initialData = {};
        }
    }

    let select = $('.select2-food-codes');
    let currentCodeElement = null;

    select.select2({
        tags: true,
        placeholder: 'Zadejte kód jídla...',
        language: {
            noResults: function() {
                return 'Zadejte kód jídla';
            }
        },
        selectOnClose: true,
        dropdownParent: $('.code-color-picker'),
        data: Object.entries(initialData).map(([code, color]) => ({
            id: code,
            text: code,
            color: color
        })),
        templateResult: function(data) {
            if (data.loading) return data.text;
            return $('<span class="select2-food-code-item">' + data.text + '</span>');
        },
        templateSelection: function(data) {
            if (!data.id) return data.text;

            let color = data.color || 'white';
            updateHiddenInput();
            return $(
                '<span class="select2-food-code-item" style="background-color: ' + color + '">' +
                data.text +
                '<i class="fas fa-palette color-pick-btn"></i>' +
                '</span>'
            );
        }
    }).on('select2:select', function(e) {
        let data = e.params.data;
        data.color = initialData[data.id] || '#024f94';
        updateHiddenInput();
    }).on('select2:unselect', function(e) {
        let removedCode = e.params.data.id;
        select.find('option[value="' + removedCode + '"]').remove(); // Remove from select
        updateHiddenInput();
    });

    if (initialData) {
        Object.keys(initialData).map(key => ({ id: key, text: key }));
        select.val(Object.keys(initialData)).trigger('change');
    }
    function updateHiddenInput() {
        let select = $('.select2-food-codes');
        let data = select.select2('data');
        let colorData = {};

        data.forEach(function(item) {
            if (item.text && item.color) {
                colorData[item.text] = item.color;
            }
        });

        // Update our separate hidden input
        $('#foodCodeColorsData').val(JSON.stringify(colorData));
    }
    updateHiddenInput();
    $(document).on('click', '.color-pick-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        currentCodeElement = $(this).closest('.select2-food-code-item');
        $('#colorPalette').toggle();
    });

    $('.color-option').click(function() {
        if (!currentCodeElement) return;

        let color = $(this).data('color');
        currentCodeElement.css('background-color', color);

        let select = $('.select2-food-codes');
        let data = select.select2('data');
        let code = currentCodeElement.text().trim();

        data.forEach(function(item) {
            if (item.text === code) {
                item.color = color;
            }
        });

        updateHiddenInput();
        $('#colorPalette').hide();
    });

    $(document).click(function(e) {
        if (!$(e.target).closest('.color-palette, .color-pick-btn').length) {
            $('#colorPalette').hide();
        }
    });
}

function toggleTargets(checkbox, selector, useAnimation = true) {
    const targets = $(selector);
    const duration = useAnimation ? 400 : 0;

    if (checkbox.checked) {
        targets.show(duration);
    } else {
        targets.hide(duration);
    }
}